// extracted by mini-css-extract-plugin
export default {"payment-method-selector":"payment-method-selector-8381","hasNoPaymentMethod":"hasNoPaymentMethod-858e"};